import { Component, OnInit } from '@angular/core';
import {ApiTestServiceService} from './api-test-service.service'
import * as $ from "jquery";

@Component({
  selector: 'app-api-test',
  templateUrl: './api-test.component.html',
  styleUrls: ['./api-test.component.scss']
})
export class ApiTestComponent implements OnInit {

  constructor(private opta:ApiTestServiceService) { }

  ngOnInit(): void {
  }
  

  submit(url:any){
    // $.ajax({
    //   //url: "../assets/metadata/Liverpool_v_Wolverhampton_Wanderers_F24.xml",
    //   //url: "../assets/metaData/"+this.file_name,
    //   url: url,
  
    //   type: "GET",
    //   dataType: "XML",
    //   success: function (data) {
    //     console.log(data)
  
  
    //   }
    // });
   this.opta.getOptaDetail(url).subscribe({
    next: (data) => {
      console.log('data is coming', data);
    },
    error: (err) => {
      console.log('error is coming', err);
    }
  }); 
    console.log(url)
  }



}
